const errorInterceptor = (error) => {
    return error.response && (error.response.data.message || error.response.statusText) || error.message
}

export {
    errorInterceptor
}